import React from 'react';
import Layout from 'components/layout';
import Header from 'sections/header-subpage';
import FooterSection from 'sections/footer';
import YepTestimonials from 'sections/yep-testimonials';
import GetStarted from 'sections/get-started';
import Collaborators from 'sections/collaborators';
import Markdown from 'sections/markdown';
import SEO from 'components/seo';
import { useTranslation } from 'react-i18next';

const YepTemplate = ({ seoTitle, seoDescription, data = {} }) => {
  const { strapiPages } = data;
  const [t] = useTranslation();

  return (
    <Layout>
      <SEO title={seoTitle} description={seoDescription} />
      <Header
        title={t('yep-page.heading')}
        subtitle={t('yep-page.subheading')}
        buttonLabel={t('yep-page.cta-label')}
        image={strapiPages && strapiPages.headerImage}
      />

      <Markdown source={t('yep-page.content')} />
      <YepTestimonials />
      <GetStarted />
      <Collaborators />
      <FooterSection />
    </Layout>
  );
};

export default YepTemplate;
